import NotificationsSettingsPage from "@/pages/settings/notifications/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/settings/notifications")({
    component: NotificationsSettingsPage,
});
